var module = angular.module('octopusApp.projects');

module.controller('TenantVariablesProjectsController', function ($scope, $q, $state, tenantState, tabState,  busy, octopusRepository, unsavedChanges, missingTenantVariablesLoader, sensitiveValue) {
    var vm = this;
    var tenantId = tenantState.tenantId;
    vm.projectTemplateDetails = [];
    vm.hasProjectTemplates = false;
    vm.filteredProjectId = null;
    vm.tenantProjects = [];
    vm.save = save;
    vm.refreshTenantVariables = refreshTenantVariables;
    vm.isProjectFiltered = isProjectFiltered;

    var environmentsById = {};
    var variables;
    var accounts = [];

    vm.getResetValueFor = function(template) {
        return template.DisplaySettings && template.DisplaySettings['Octopus.ControlType'] === 'Sensitive' ? sensitiveValue.getResetValue(template.value) : template.value;
    }

    function isProjectFiltered(projectVariables){
        return projectVariables.project.Templates.length > 0 && (!vm.filteredProjectId || projectVariables.project.Id === vm.filteredProjectId);
    }

    function isAzureAccountTemplate(template) {
        return template.DisplaySettings['Octopus.ControlType'] === 'AzureAccount';
    }

    function init() {
        tenantState.missingVariables = missingTenantVariablesLoader.missingVariables(tenantId);

        tabState.isLoading.promise(tenantState.load().then(function (tenant) {
            vm.tenant = tenant;
            return $q.all([loadEnvironments(tenant), loadVariables(tenant)]);
        }).then(function(){
            return loadAccountsConditionally();
        }).then(function () {
            setApplicableProjects();
            refreshTenantVariables();
            setInitialProjectFilter();
        }));

        tabState.isLoading.promise(tenantState.missingVariables.loadingAsync);
    }

    function loadVariables(tenant) {
        return octopusRepository.Tenants.getVariables(tenant).then(function (tenantVariables) {
            variables = tenantVariables;
        });
    }

    function loadEnvironments(tenant) {
        var environmentIds = _.unique(_.flatten(_.values(tenant.ProjectEnvironments)));
        return octopusRepository.Environments.all({ids: environmentIds}).then(function (environments) {
            environmentsById = _.object(_.pluck(environments, "Id"), environments);
        });
    }

    function loadAccountsConditionally() {
        if(_.any(variables.ProjectVariables, function(pv) {
            return _.any(pv.Templates, isAzureAccountTemplate);
        })){
            return octopusRepository.Accounts.all().then(function (acc) {
                accounts = acc;
            });
        }
    }

    function setApplicableProjects() {
        vm.tenantProjects =_.map(variables.ProjectVariables, function(pv) {
            return {
                Id: pv.ProjectId,
                Name: pv.ProjectName,
                Links: pv.Links,
                Templates: pv.Templates
            };
        });
    }

    function setInitialProjectFilter() {
        // In the past we were showing all projects by default, but rendering large numbers of variables
        // proved to be a performance issue. So now we set an initial project filter.
        if (vm.hasProjectTemplates) {
            // If there are any projects with missing variable values, then filter to the first of these
            var firstProjectWithMissingValues = _.find(vm.projectTemplateDetails, function(t) { return t.hasMissing; });

            if (firstProjectWithMissingValues) {
                vm.filteredProjectId = firstProjectWithMissingValues.project.Id;
            } else {
                // Else, default to the first project
                vm.filteredProjectId = vm.projectTemplateDetails[0].project.Id;
            }
        }
    }

    function cloneTemplatesWithValues(projectVariable, envId, variables) {
        return projectVariable.Templates.map(function (template) {
            var templateCopy = _.clone(template);
            if (isAzureAccountTemplate(template)) {
                templateCopy.selectOptions = {
                    'AzureAccount': accounts.filter(function (acc) {
                        return !acc.EnvironmentIds || acc.EnvironmentIds.length === 0 || acc.EnvironmentIds.indexOf(envId) !== -1;
                    })
                };
            }
            templateCopy.DisplaySettings = _.clone(template.DisplaySettings);
            templateCopy.value = variables[template.Id] || template.DefaultValue;
            templateCopy.isMissingValue = tenantState.missingVariables.isMissing(template.Id, envId);
            return templateCopy;
        });
    }

    function refreshTenantVariables() {
        vm.hasProjectTemplates = false;
        vm.projectTemplateDetails = _.map(variables.ProjectVariables, function(projectVariable) {
            var templates = _.map(projectVariable.Variables, function (variables, envId) {
                return {
                    environmentId: envId,
                    environment: environmentsById[envId],
                    templates: cloneTemplatesWithValues(projectVariable, envId, variables)
                };
            });

            vm.hasProjectTemplates = vm.hasProjectTemplates || projectVariable.Templates.length > 0;
            return {
                project: _.find(vm.tenantProjects, function(proj) { return proj.Id === projectVariable.ProjectId; }),
                environmentIds: Object.keys(projectVariable.Variables),
                templatesByEnvironment: templates,
                hasMissing: _.chain(templates)
                    .map(function(t){ return t.templates; })
                    .flatten()
                    .some(function(t){ return t.isMissingValue; })
                    .value()
            };
        });
    }

    function save() {
        variables.ProjectVariables = modelToResource();
        tenantState.isSaving.promise(octopusRepository.Tenants.setVariables(vm.tenant, variables).then(function (a) {
            unsavedChanges.saved();
            init();
        }));

        function modelToResource() {
            return vm.projectTemplateDetails.reduce(function(idx, val) {
                idx[val.project.Id] = {
                    ProjectId: val.project.Id,
                    ProjectName: val.project.Name,
                    Templates: val.project.Templates,
                    Variables: mapEnvironmentsToResource(val.templatesByEnvironment)
                };
                return idx;
            }, {});

            function mapEnvironmentsToResource(templatesByEnvironment){
                return templatesByEnvironment.reduce(function(idx, val){
                    idx[val.environmentId] =  mapTemplatesToResource(val.templates);
                    return idx;
                }, {});
            }

            function mapTemplatesToResource(templates){
                return templates.reduce(function(a, b) { a[b.Id] = b.value; return a;}, {});
            }
        }
    }

    init();
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/variables/tenant_variables_projects.js
// module id = 1337852448869952
// module chunks = 1